<template>
    <section class="text-white adolfo-career-bg">
      <b-container class="">
            <b-row>
                <b-col sm="12" md="12" lg="12" style="margin-top: 120px;">
                    <h1 class="text-left font-weight-bold">
                        <span>NOMINACIONES</span> Y CAMPAÑAS
                    </h1>
                    <Timeline
                            :timeline-items="dataTimeline"
                            :message-when-no-items="messageWhenNoItems"
                            :unique-year="true"
                            order="desc"
                            colorDots="#ed4630"
                    />
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
    import Timeline from 'timeline-vuejs'

    export default {
        name: "Nominations",
        data: () => ({
            messageWhenNoItems: "There arent items",
            dataTimeline: [
                {
                    from: new Date(2017, 1),
                    title: "Espectacular JAP “ARRE”",
                    description:
                        "Mejor pieza gráfica en vía pública"
                },
                {
                    from: new Date(2017, 1),
                    title: "JAP “ARRE”",
                    description:
                        "Mejor Slogan de campaña electoral"
                },
                {
                    from: new Date(2018, 1),
                    title: "El cambio se ve",
                    description:
                        "Mejor campaña de comunicación Gubernamental"
                },
                {
                    from: new Date(2018, 1),
                    title: "Paga tu Predial (Rosa Concha)",
                    description:
                        "Mejor Slogan de campaña electoral"
                },
                {
                    from: new Date(2018, 1),
                    title: "Héroe de noche",
                    description:
                        "Mejor campaña de concientización social"
                },
                {
                    from: new Date(2018, 1),
                    title: "Ciudad en equipo",
                    description:
                        "Mejor campaña de marca ciudad, estado o país"
                },
                {
                    from: new Date(2019, 1),
                    title:"Hechos son amores",
                    description: "Mejor campaña de informe de gobierno"
                },
                {
                    from: new Date(2019, 1),
                    title: "Casa Mudéjar",
                    description: "Mejor spot campaña gubernamental en redes sociales"
                },
                {
                    from: new Date(2019, 1),
                    title:"Donde nace la vida",
                    description: "Mejor slogan de campaña de gobierno"
                },
                {
                    from: new Date(2019, 1),
                    title:"Bájale a tu ruido",
                    description: "Mejor campaña de concientización social"
                },
                {
                    from: new Date(2019, 1),
                    title:"Cuatro Ciénegas",
                    description: "Mejor campaña de promoción turística"
                },
                {
                    from: new Date(2019, 1),
                    title:"Márcale 073",
                    description: "Mejor spot de gobierno que nunca vio la luz"
                },


            ]
        }),
        components: {
            Timeline
        }
    }
</script>

<style scoped>

</style>
